<template>
  <div
    :id="data? data.url: ''"
    class="page"
  >
    <template v-if="!loading">
      <Banner :banner="page.banner" />
      <section
        id="content_section"
        class="container bg-white text-left"
      >
        <div class="row">
          <div
            class="py-4"
            :class="page.sidemenu? 'col-lg-9 order-lg-2': 'col-lg-12'"
          >
            <Breadcrumb :items="breadcrumb" />
            <div class="content py-4">
              <h1
                v-if="page.heading"
                class="articleTitle text-osc"
              >
                {{ page.heading }}
              </h1>
              <div
                v-if="!loading && data"
                class="articleBodyFullWidth"
              >
                <div class="articleContent">
                  <Banners
                    v-if="data.banners && data.banners.length > 0"
                    :banners="data.banners"
                    :options="{dots: true, infinite: true, arrows: false}"
                  />

                  <template v-if="data.form">
                    <h5
                      v-if="data.to"
                      class="text-osc"
                    >
                      {{ $t("component.form.deadline") }}: {{ data.to | moment("D MMM YYYY (dddd)") }}
                    </h5>
                    <h5
                      v-else-if="data.form_deadline"
                      class="text-osc"
                    >
                      {{ $t("component.form.deadline") }}: {{ data.form_deadline | moment("H a, dddd, D MMM YYYY") }}
                    </h5>
                    <b-link
                      v-if="path === 'proposal/edit'"
                      class="btn btn-info text-white mt-2"
                      :to="'/proposal/logout'"
                    >
                      {{ $t("component.proposal.logout") }}
                    </b-link>
                    <div
                      v-if="data.body"
                      v-lazy-container="{ selector: 'img' }"
                      class="mb-3"
                      v-html="filterHTML(data.body)"
                    />
                    <Form
                      :form="data.form"
                      :url="path"
                      :footer="data.footer"
                      :is_edit="true"
                    />
                  </template>

                  <template v-else>
                    <div
                      v-if="data.body"
                      v-lazy-container="{ selector: 'img' }"
                      class="mb-3"
                      v-html="filterHTML(data.body)"
                    />
                    <Gallery
                      v-if="data.videos"
                      :videos="data.videos"
                    />
                  </template>
                </div>
              </div>
            </div>
          </div>
          <SideMenu
            v-if="page.sidemenu"
            class="py-4 col-lg-3 order-lg-1"
            :data="page.sidemenu"
          />
        </div>
      </section>
      <section
        id="donate_btn_section"
        class="container bg-white py-4 clearfix d-none d-md-block"
      >
        <DonateBtn
          v-view.once
          class="animated fadeInRight"
        />
      </section>
    </template>
  </div>
</template>
<script>
import Banner from "@/components/Banner.vue";
import Banners from "@/components/Banners.vue";
import DonateBtn from "@/components/DonateBtn.vue";
import SideMenu from "@/components/SideMenu.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Gallery from "@/components/Gallery.vue";
import Form from "@/components/Form.vue";
import * as _ from "lodash";

export default {
  name: "Proposal",
  components: {
    Banner,
    Banners,
    DonateBtn,
    SideMenu,
    Breadcrumb,
    Gallery,
    Form
  },
  data() {
    return {
      // default
      path: this.$router.history.current.path.substr(1),
      loading: true,
      page: null,
      data: null,
      breadcrumb: []
    };
  },
  watch: {
    $route(to, from) {
      if (to.path == "/proposal/edit/login" && from.path == "/proposal/edit") {
        localStorage.removeItem("token"); // Clear Token if failed request from proposal edit
      }
      this.path = to.path.substr(1);
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;

      this.page = {
        // Default Settings for page
        sidemenu: null,
        banner: null,
        title: this.$t("page." + this.path),
        heading: null
      };

      var getOptions = {};
      var token = localStorage.getItem("token");
      switch (this.path) {
        case "proposal/edit/login":
          if (token) {
            this.$router.replace("/proposal/edit");
          }
          break;
        case "proposal/edit":
          if (token) {
            getOptions["headers"] = { Authorization: "Bearer " + token };
          } else {
            this.$router.replace("/proposal/edit/login");
          }
          break;
        case "proposal/logout":
          localStorage.removeItem("token");
          this.$router.replace("/proposal/edit/login");
          break;
      }

      this.$http
        .get(this.path, getOptions)
        .then(response => {
          if (response.data.success) {
            this.data = response.data.data;

            this.page.banner = this.data.image;
            this.page.title =
              this.getDataValue("name", this.data) || this.page.title;
            this.page.heading =
              this.getDataValue("headline", this.data) || this.page.heading;
            this.$route.meta.title = this.page.title;
            this.$route.meta.desc = this.data.desc;

            // Get Form Name for Page Heading
            if (this.data && this.data.form) {
              // if (form.form_name) {
              //   this.page.heading = form.form_name;
              // }
              if (this.path == "proposal") {
                let idx = _.findIndex(this.data.form.fields, {
                  fieldname: "src"
                });
                if (idx == -1) {
                  this.data.form.fields.push({
                    fieldname: "src",
                    default_value: "OSC",
                    fieldtype: "hidden"
                  });
                  idx = this.data.form.fields.length - 1;
                }
                let default_value = this.data.form.fields[idx].default_value;
                if (!default_value || default_value == "") {
                  default_value = "OSC";
                }
                this.data.form.fields[idx].default_value =
                  !this.$route.query.src || this.$route.query.src == ""
                    ? default_value
                    : this.$route.query.src;
              }
            }

            // Get Data for Module
            if (this.data && this.data.data) {
              var real_data = this.data.data;
              this.data.body = real_data.body;
              this.data.images = real_data.images;
              delete this.data.data;
            }

            // Get Image Slider
            if (!_.isEmpty(this.data.images)) {
              var banners = [];
              var images = JSON.parse(this.data.images);
              for (let i = 0; i < images.length; i++) {
                banners.push({ image: images[i] });
              }
              this.data.banners = banners;
            }

            let past_bene =
              this.data &&
              this.getDataValue("left_menu_header", this.data) ==
                this.$t("component.past_beneficiaries");
            if (this.data && this.data.left_menus) {
              this.page.sidemenu = {
                parent: this.path,
                title: this.data.left_menu_header,
                items: this.data.left_menus,
                past_bene: past_bene
              };
            } else if (past_bene) {
              this.page.sidemenu = {
                past_bene: past_bene
              };
            }
          } else throw { response: response };
        })
        .catch(error => {
          this.handleFailedRequest(error.response);
        })
        .finally(() => {
          this.$meta().refresh(); // Important!
          this.breadcrumb = [];
          this.breadcrumb.push({ name: this.page.title, url: this.path });
          this.loading = false;
        });
    },
    handleFailedRequest(response) {
      let data = response ? response.data : null;
      if (data && data.redirect && data.redirect.url) {
        localStorage.removeItem("token");
        this.$router.push(data.redirect.url);
      } else if (
        response &&
        (response.status === 404 || response.status === 401)
      ) {
        localStorage.removeItem("token");
        this.$router.replace("/404");
      }
    }
  }
};
</script>